window.REGION_ZIPCODES = {
  4965000: "94538",
  8765999: "99202",
  8766999: "97301",
  8767999: "98409",
  8768901: "95348",
  8768902: "93710",
  8768903: "93304",
  8769901: "92821",
  8769902: "92308",
  8771999: "83706",
  8772999: "89502",
  8773999: "87114",
  8774901: "85308",
  8774902: "85122",
  8775999: "99352",
  8776999: "85365",
};